import { useEffect } from 'react';
import { useMapContext } from 'widgets/earthMap/contexts/mapContext';

export default function useIsVisible({ layerName }: { layerName: string }) {
	const [{ map, isClustered }] = useMapContext();

	useEffect(() => {
		if (!map) return;
		const layer = map.getLayer(layerName);
		if (!layer) return;
		const visibility = isClustered ? 'none' : 'visible';
		map.setLayoutProperty(layerName, 'visibility', visibility);
	}, [isClustered, map, layerName]);
}
